
export class UserData {

	code?: string;
	active?: boolean;
	name?: string;
	email: string;
	username?: string;
	phone?: string;
	address?: string;
	role?: string;
	profileImagePath?: string;
	profileImageUrl?: string;
	admin?: boolean;
	companies?: string[];
	modules?: string[];
}

export class User extends UserData {

	id: string;
}
